import React, { FC } from "react";
import { IWizardStepContent } from "../../../../wizard/types";
import { DetailImages } from "../../components";
import { AccordionList } from "../../../../../components/AccordionList";
import { courseDetailsConfig } from "../../../constants";

const Content: FC<IWizardStepContent> = ({ stepName }) => (
  <>
    <AccordionList
      title="Course Details"
      fieldName={`${stepName}.details`}
      configs={courseDetailsConfig}
    />
    <DetailImages fieldsGroupName={stepName} />
  </>
);

export default Content;
